import { DefaultService } from '@/services/DefaultService';

export default class CockpitVendasService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    getClientesVisita(filtros) {
        return this._http.post(`${this._env}/cockpit-agro/clientes-visita`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getClientesAtendimentos(filtros) {
        return this._http.post(`${this._env}/cockpit-agro/clientes-atendimentos`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getAtendimentoPorMotivo(filtros) {
        return this._http.post(`${this._env}/cockpit-agro/atendimento-por-motivo`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getAtendimentoPorAssunto(filtros) {
        return this._http.post(`${this._env}/cockpit-agro/atendimento-por-assunto`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getCulturaSafra(filtros) {
        return this._http.post(`${this._env}/cockpit-agro/cultura-safra`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getClientesPorVendedor(filtros) {
        return this._http.post(`${this._env}/cockpit-agro/clientes-por-vendedor`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getClientePorCidade(filtros) {
        return this._http.post(`${this._env}/cockpit-agro/cliente-por-cidade`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    /*
        @85840 - dashboard colaborador - cliente x atendimento x agro visita, onde é agrupado por colaborador
    */
    getColaboradorClienteAtendimentoAgrovisita(filtros) {
        return this._http.post(`${this._env}/cockpit-agro/colaborador-cliente-atendimento-agrovisita`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }
    /*
        @85833 - dashboard visitas x empresa que mostra a quantidade de visitas feitas por cliente em cada empresa
    */
    getVisitasEmpresa(filtros) {
        return this._http.post(`${this._env}/cockpit-agro/visitas-empresa`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getColaboradorVisitaPeriodoDia(filtros) {
        return this._http.post(`${this._env}/cockpit-agro/colaborador-visita-periodo-do-dia`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }
    

    getClientePlanoSafraAgroVisita(filtros) {
        return this._http.post(`${this._env}/cockpit-agro/chart-clientes-plano-safra-agro-visita`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getOcorrencia(filtros) {
        return this._http.post(`${this._env}/cockpit-agro/ocorrencia`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }
    getVisitaColaborador(filtros) {
        return this._http.post(`${this._env}/cockpit-agro/visitas-colaborador`, filtros, this._headers)
        .then(res => res.body, this.handleError);
    }

    saveChartLayout(layout) {
        return this._http.post(`${this._env}/cockpits`, layout, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getChartLayout(tipo) {
        return this._http.get(`${this._env}/cockpits/${tipo}.json`, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getChartAgroAtendimentos(filtros) {
        return this._http.post(`${this._env}/cockpit-agro/agro-atendimentos`, filtros, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getAll() {
        return this._http.get(`${this._env}/cockpit-agro/charts.json`, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getCharts(chart) {
        return this._http.post(`${this._env}/cockpit-sales/chart.json`, chart, this._headers)
                        .then(res => res.body, this.handleError);
    }

    getChartByTitulo(titulo, filters) {
        return this._http.post(`${this._env}/cockpit-agro/chart/${titulo}`, filters, this._headers)
                        .then(res => res.body, this.handleError);
    }

    delete(id) {
        return this._http.delete(`${this._env}/cockpit-agro/delete-chart/${id}`, this._headers)
                        .then(res => res.body, this.handleError);
    }
}